import { useMutation, UseMutationOptions } from 'react-query';
import { mutateSettleRace } from './settleRace';
import { TSettleRaceBody } from './settleRace.types';

export const useMutationSettleRace = (
  options?: UseMutationOptions<unknown, unknown, TSettleRaceBody>
) => useMutation((data) => mutateSettleRace(data), options);
